module.exports = __webpack_public_path__ + "static/media/Illus-Diversity_1@3x.d2b70f94.png";